/**
 * @generated SignedSource<<b883f85a798a72a16cc53c5b93cb214f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly " $fragmentType": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment";
};
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";

export default node;
